import { ThreadInput } from 'src/services/graphql/Models';
import { DataClass } from 'src/shared/utility';

export default class Thread implements ThreadInput, DataClass {
  clientId: string;
  typedId: string;
  context?: string | null;
  brief?: string | null;
  detail?: string | null;
  
  constructor ( from: any ) { 
    this.clientId = from.clientId;
    this.typedId = from.typedId;
    this.context = from.context;
    this.brief = from.brief;
    this.detail = from.detail;
  }

  parseAbsolute() {
    return {
      clientId: this.clientId,
      typedId: this.typedId,
      context: this.context,
      brief: this.brief,
      detail: this.detail
    };
  }
}


// WEBPACK FOOTER //
// ./src/stores/application/classes/Thread.ts